import React, { Fragment, useState, useEffect } from "react";
import QueryService from "../../services/QueryService";
import { useHistory, useLocation } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
// Removed PersonIcon (buttons now text-only)
import { makeStyles } from "@mui/styles";
import SaveModal from "../saveModal/SaveModal";
import CustomLoader from "../customLoader/CustomLoader";
import ErrorModal from "../errorDisplayModal/ErrorDisplayModal";
import Loader from "react-loader-spinner";
import SweetAlert from "react-bootstrap-sweetalert";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import { changeQueryLocation } from "../../reducers/locationReducer";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import { Modal } from "reactstrap";
// Icon-based pagination assets (same as MessageTemplate)
import pageLeft from "../../assets/images/CounselorCurrent/Page/left.png";
import pageLeftHide from "../../assets/images/CounselorCurrent/Page/left-hide.png";
import pageRight from "../../assets/images/CounselorCurrent/Page/right.png";
import pageCenter from "../../assets/images/CounselorCurrent/Page/center.png";
import "./QueryResult.css";

const useStyles = makeStyles({
  root: {
    "& .super-app-theme--header": {
      fontSize: "14px",
    },
  },
});

const ShowAlert = ({ number, onCancel, onConfirm }) => (
  <SweetAlert
    warning
    showCancel
    showConfirm
    showCloseButton
    title={
      <p
        style={{ fontSize: "20px" }}
      >{`You have selected ${number} students!`}</p>
    }
    onConfirm={onConfirm}
    onCancel={onCancel}
    btnSize="sm"
  >
    Are you Sure ?
  </SweetAlert>
);

const QueryResultCCCComponent = () => {
  let history = useHistory();
  let location = useLocation();
  console.log("location from the result", location);
  //const resultData = location?.state?.state;
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [sortModel, setSortModel] = useState([]); // MUI DataGrid sort model
  const [isModalOpen, setModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(20);
  const [queryResultData, setQueryResultData] = useState();
  const [tableData, setTableData] = useState(0);
  //const [exportData, setExportData] = useState(location && location.state && location.state.state && location.state.state.export)
  //const [stuPag, setStuPag] = useState(location.state.state.stud_arr);
  //const [dataForAllSelected, setDataForAllSelected] = useState(exportData.shift())
  const [clickedStudent, setClickedStudent] = useState();
  const [openSaveModal, setOpenSaveModal] = useState(false);
  //const [saveQueryData, setSaveQuerydata] = useState(resultData ? resultData.shift() : '')
  const [duplicateQueryData, setDuplicateQueryData] = useState(
    location && location.state ? location.state.duplicateQueryData : ""
  );
  //const [payloadForSaveResult, setPayloadForSaveResult] = useState(location && location.state && location.state.queryResultData ? location.state.queryResultData : '')
  const [from, setFrom] = useState(location?.state?.fromSavedQueriedResult);
  const [paginationCount, setPaginationCount] = useState();
  const [inputValue, setInputValue] = useState("");
  const [selectedRowFromTable, setSelectedRowFromTable] = useState();
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  const [selectedRowFromResultTable, setSelectedRowFromResultTable] = useState(
    []
  );
  const [saveSelection, setSaveSelection] = useState([]);
  const prevSelectionModel = React.useRef(selectedRowFromResultTable);
  const prevSelectionModelData = React.useRef(saveSelection);
  const [loaderForExport, setLoaderForExport] = useState(false);
  const [loaderForSave, setLoaderForSave] = useState(false);
  const [showGroupMessageAlert, setShowGroupMessageAlert] = useState(false);
  const [filteredSaveSelection, setFilteredSaveSelection] = useState([]);
  const [newSelectedIds, setNewSelectedIds] = useState([]);
  const [expandedCells, setExpandedCells] = useState({}); // Track expanded cells

  const [hideSaveResultButton, setHideSaveResultButton] = useState(
    location?.state?.from
  );
  const dispatch = useDispatch();

  let userData = useSelector((state) => state.UserReducer.userObj);

  const selectedAllData = location?.state?.state?.export.filter(
    (item) => item.hasOwnProperty("id") === true
  );

  // console.log(saveQueryData, from)
  const navigateToQuery = () => {
    localStorage.removeItem("query");
    history.push("/recruiter/college-query");
  };

  // Map DataGrid column field to backend sort field
  const sortFieldMap = {
    "0": "email",
    "1": "first_name",
    "2": "last_name",
    "3": "ethnicity",
    "4": "gender",
    "5": "overall_gpa",
    "6": "activities",
    "7": "athletics",
    "8": "interests",
    "9": "academics",
    "10": "school_name",
  };

  // useEffect(() => {
  //     if (openSaveModal === false) {
  //         location.state.openSaveModal = false
  //     }
  // }, [openSaveModal])

  const getPageData = (overrideSort) => {
    setLoading(true);
    let queryData = JSON.parse(localStorage.getItem("query"));
    if (queryData) {
      queryData.page = page;
      // attach server-side sort when requested
      const rule = overrideSort || (sortModel && sortModel[0]);
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          queryData.sort_by = rule.sort === "desc" ? "desc" : "asc";
          queryData.field = mapped;
        } else {
          // remove sort params if column isn't supported by backend
          delete queryData.sort_by;
          delete queryData.field;
        }
      } else {
        delete queryData.sort_by;
        delete queryData.field;
      }
    }

    QueryService.getCollegeResultPage(queryData)
      .then(async (data) => {
        setQueryResultData(data.data);
        console.log(data.data.student_list);
        const newArrayOfObj = data.data.student_list.map(
          ({ 11: id, ...rest }) => ({
            id,
            ...rest,
          })
        );
        //console.log(newArrayOfObj);
        setTableData(newArrayOfObj);
        setPaginationCount(data.data.total_pages);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("error from the service", error);
      });
  };

  // useEffect(()=>{
  //     console.log("getting called from the useEffect", exportData)
  // },[exportData])

  const convertArrayToTable = async (apiArray, fileName) => {
    const tableRows = apiArray
      .map((obj) => [
        `<tr>
              ${Object.keys(obj)
                .map(
                  (key) =>
                    `<td>${
                      obj[key] === null || key === "id" || obj[key] === ""
                        ? ""
                        : obj[key]
                    }</td>`
                )
                .join("")}
           <tr/>`,
      ])
      .join("");
    const table = `<table>${tableRows}</table>`?.trim();
    const xmlTable = createXMLTable(table, fileName);
    const downloadURL = createFileUrl(xmlTable);
    downloadFile(downloadURL, fileName);
  };

  const createXMLTable = (table, fileName) => {
    const xmlTable = `
              <html xmlns:o="urn:schemas-microsoft-com:office:office xmlns:x="urn:schemas-microsoft-com:office:excel"
             xmlns="http://www.w3.org/TR/REC-html40"
              >
                 <meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"/>
                 <head>
                    <xml>
                      <x:ExcelWorkbook>
                          <x:ExcelWorksheets>
                              <x:ExcelWorksheet>
                                  <x:Name>${fileName}</x:Name>
                                  <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
                              </x:ExcelWorksheet>
                          </x:ExcelWorksheets>
                      </x:ExcelWorkbook>
                    </xml>
                 </head>
                 <body>
                   ${table}
                 </body>
              </html> `;
    return xmlTable;
  };

  const createFileUrl = (xmlTable) => {
    const tableBlob = new Blob([xmlTable], {
      type: "application/vnd.ms-excel;base64,",
    });
    const downloadURL = URL.createObjectURL(tableBlob);
    return downloadURL;
  };

  // useEffect(()=>{
  //     downloadFile(csvfile, "Test Download")
  // },[])

  const downloadFile = (downloadURL, fileName) => {
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    downloadLink.download = fileName;
    downloadLink.href = downloadURL;
    downloadLink.click();
  };

  const exportResult = () => {
    setLoaderForExport(true);
    let query = JSON.parse(localStorage.getItem("query"));
    // attach current sort rule to export payload
    if (query) {
      const rule = sortModel && sortModel[0];
      if (rule && rule.field) {
        const mapped = sortFieldMap[rule.field];
        if (mapped) {
          query.sort_by = rule.sort === "desc" ? "desc" : "asc";
          query.field = mapped;
        } else {
          delete query.sort_by;
          delete query.field;
        }
      } else {
        delete query.sort_by;
        delete query.field;
      }
    }
    QueryService.exportResultCCC(query)
      .then((data) => {
        console.log("data from the service", data);
        downloadFile(data.data.download, "My File");
        setLoaderForExport(false);
      })
      .catch((error) => {
        setLoaderForExport(false);
        console.log("error from the service", error);
      });
  };
  useEffect(() => {
    if (!from) {
      getPageData();
    }
  }, [page]);

  useEffect(() => {
    if (from) {
      setTableData(selectedAllData);
    }
  }, []);

  const onCounselorContact = (cell) => {
    console.log("Counselor contact clicked");
    console.log("Cell data:", cell);
    
    // Get counselor name and ID from positions - adjust these based on your data structure
    const counselorName = cell.row["counselor_name"] || "Counselor";
    const counselorId = cell.row["counselor_id"] || cell.row.id;
    
    if (counselorId) {
      history.push({
        pathname: "/recruiter/counselors",
        state: {
          name: counselorName,
          id: counselorId
        },
        openMessageModal: true,
        fromQueryResult: true
      });
    } else {
      console.error("No counselor ID found");
    }
  };

  const onStudentContact = (cell) => {
    console.log("Student contact clicked");
    console.log("Cell data:", cell);
    
    // Use the 'id' field instead of "11"
    const studentId = cell.row.id;  // This is the transformed field
    console.log("Student ID:", studentId);
    
    if (studentId) {
      history.push({
        pathname: "/recruiter/students",
        state: {
          name: `${cell.row["1"]} ${cell.row["2"]}`,
          id: studentId
        },
        openMessageModal: true,
        fromQueryResult: true
      });
    } else {
      console.error("No student ID found");
    }
  };

  console.log(filteredSaveSelection);
  const onGroupMessage = () => {
    history.push( {
    pathname: '/recruiter/students',
    state: filteredSaveSelection,
    openMessageModal: true,
    fromQueryResult: true,
    payloadForSaveResult:queryResultData?.total_students,
    page:page,
})
}

  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };

  const toggleCellExpansion = (rowId, field) => {
    const key = `${rowId}-${field}`;
    setExpandedCells(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const saveStudent = () => {
    setLoaderForSave(true);
    let payload;
    if (saveSelection === "selected All") {
      let detailObj = {};
      let finalObj = newSelectedIds.map((i, index) => {
        detailObj[index] = { school_id: i["15"], student_id: i["16"] };
      });
      payload = {
        is_all: false,
        details: detailObj,
      };
    } else {
      let detailObj = {};
      saveSelection.map((i, index) => {
        detailObj[index] = { school_id: i["15"], student_id: i["16"] };
      });
      payload = {
        is_all: false,
        details: detailObj,
      };
    }
    QueryService.saveStudent(payload)
      .then((res) => {
        setLoaderForSave(false);
        swal("", "Student Saved Successfully", "success");
        setSaveSelection([]);
        setSelectedRowFromResultTable([]);
      })
      .catch((err) => {
        setLoaderForSave(false);
        console.log(err);
      });
  };
  const columns = [
    {
      field: "clickToContact",
      headerName: "Click to Contacts",
      headerClassName: "super-app-theme--header",
      minWidth: 320,
      flex: 0.8,
      renderCell: (cell) => {
        return (
          <div className="contact-button-container" style={{ 
            display: 'flex', 
            flexDirection: 'row', 
            gap: '12px', 
            padding: '6px',
            width: '100%',
            alignItems: 'center'
          }}>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onCounselorContact(cell);
              }}
              className="contact-button"
              style={{
                backgroundColor: '#009900',
                color: 'white',
                border: '2px solid #009900',
                boxShadow: 'inset 0 0 0 2px #ffffff',
                borderRadius: '24px',
                padding: '6px 24px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '140px',
                width: '100%',
                justifyContent: 'center',
                marginBottom: '4px',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#007700';
                e.target.style.borderColor = '#007700';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#009900';
                e.target.style.borderColor = '#009900';
              }}
            >
              Counselor
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onStudentContact(cell)
              }}
              className="contact-button"
              style={{
                backgroundColor: '#1395F2',
                color: 'white',
                border: '2px solid #1395F2',
                boxShadow: 'inset 0 0 0 2px #ffffff',
                borderRadius: '24px',
                padding: '6px 24px',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                minWidth: '140px',
                width: '100%',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                whiteSpace: 'nowrap'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#0f7bc7';
                e.target.style.borderColor = '#0f7bc7';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#1395F2';
                e.target.style.borderColor = '#1395F2';
              }}
            >
              Student
            </button>
          </div>
        );
      },
    },
    {
      field: "0",
      headerName: "Email Address",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: "280",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: '8px',
          fontSize: '13px',
          color: '#1e40af',
          fontWeight: '500'
        }}>
          <span style={{ 
            backgroundColor: '#eff6ff', 
            padding: '4px 8px', 
            borderRadius: '6px',
            fontSize: '12px'
          }}>
            {params.value || 'No email'}
          </span>
        </div>
      ),
    },
    {
      field: "1",
      headerName: "First Name",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: "150",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          fontWeight: '600', 
          color: '#059669',
          fontSize: '14px'
        }}>
          {params.value || '-'}
        </div>
      ),
    },
    {
      field: "2",
      headerName: "Last Name",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: "150",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          fontWeight: '600', 
          color: '#059669',
          fontSize: '14px'
        }}>
          {params.value || '-'}
        </div>
      ),
    },
    {
      field: "3",
      headerName: "Ethnicity",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: "120",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          backgroundColor: params.value ? '#f0f9ff' : '#f9fafb',
          color: params.value ? '#0369a1' : '#6b7280',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          textAlign: 'center'
        }}>
          {params.value || 'Not specified'}
        </div>
      ),
    },
    {
      field: "4",
      headerName: "Gender",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: "100",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          backgroundColor: params.value === 'Male' ? '#fef3f2' : params.value === 'Female' ? '#f0f9ff' : '#f9fafb',
          color: params.value === 'Male' ? '#dc2626' : params.value === 'Female' ? '#2563eb' : '#6b7280',
          padding: '4px 8px',
          borderRadius: '12px',
          fontSize: '12px',
          fontWeight: '500',
          textAlign: 'center'
        }}>
          {params.value || 'Not specified'}
        </div>
      ),
    },
    {
      field: "5",
      headerName: "Overall GPA",
      headerClassName: "super-app-theme--header",
      type: "number",
      minWidth: "120",
      resizable: true,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          backgroundColor: params.value >= 3.5 ? '#f0fdf4' : params.value >= 3.0 ? '#fffbeb' : params.value >= 2.5 ? '#fef2f2' : '#f9fafb',
          color: params.value >= 3.5 ? '#059669' : params.value >= 3.0 ? '#d97706' : params.value >= 2.5 ? '#dc2626' : '#6b7280',
          padding: '4px 8px',
          borderRadius: '8px',
          fontSize: '13px',
          fontWeight: '600',
          textAlign: 'center'
        }}>
          {params.value ? parseFloat(params.value).toFixed(2) : 0}
        </div>
      ),
    },
    {
      field: "6",
      headerName: "Activities",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 300,
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const isExpanded = expandedCells[`${params.row.id}-activities`];
        const items = params.value && Array.isArray(params.value) ? params.value : 
                     params.value && typeof params.value === 'string' ? params.value.split(',') : [];
        const displayItems = isExpanded ? items : items.slice(0, 2);
        const hasMore = items.length > 2;

        return (
          <div style={{ 
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxWidth: '100%',
            overflow: 'hidden'
          }}>
            {displayItems.length > 0 ? (
              displayItems.map((activity, idx) => (
                <span key={idx} style={{ 
                  backgroundColor: '#fef3f2',
                  color: '#dc2626',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '500'
                }}>
                  {activity?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>
                No activities
              </span>
            )}
            {hasMore && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCellExpansion(params.row.id, 'activities');
                }}
                style={{ 
                  color: '#6b7280',
                  fontSize: '11px',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: '2px 4px'
                }}
              >
                {isExpanded ? 'Show less' : `+${items.length - 2} more`}
              </button>
            )}
          </div>
        );
      },
    },
    {
      field: "7",
      headerName: "Athletics",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 300,
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const isExpanded = expandedCells[`${params.row.id}-athletics`];
        const items = params.value && Array.isArray(params.value) ? params.value : 
                     params.value && typeof params.value === 'string' ? params.value.split(',') : [];
        const displayItems = isExpanded ? items : items.slice(0, 2);
        const hasMore = items.length > 2;

        return (
          <div style={{ 
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxWidth: '100%',
            overflow: 'hidden'
          }}>
            {displayItems.length > 0 ? (
              displayItems.map((sport, idx) => (
                <span key={idx} style={{ 
                  backgroundColor: '#f0fdf4',
                  color: '#059669',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '500'
                }}>
                  {sport?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>
                No athletics
              </span>
            )}
            {hasMore && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCellExpansion(params.row.id, 'athletics');
                }}
                style={{ 
                  color: '#6b7280',
                  fontSize: '11px',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: '2px 4px'
                }}
              >
                {isExpanded ? 'Show less' : `+${items.length - 2} more`}
              </button>
            )}
          </div>
        );
      },
    },
    {
      field: "8",
      headerName: "Interests",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 300,
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const isExpanded = expandedCells[`${params.row.id}-interests`];
        const items = params.value && Array.isArray(params.value) ? params.value : 
                     params.value && typeof params.value === 'string' ? params.value.split(',') : [];
        const displayItems = isExpanded ? items : items.slice(0, 2);
        const hasMore = items.length > 2;

        return (
          <div style={{ 
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxWidth: '100%',
            overflow: 'hidden'
          }}>
            {displayItems.length > 0 ? (
              displayItems.map((interest, idx) => (
                <span key={idx} style={{ 
                  backgroundColor: '#fef7ff',
                  color: '#9333ea',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '500'
                }}>
                  {interest?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>
                No interests
              </span>
            )}
            {hasMore && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCellExpansion(params.row.id, 'interests');
                }}
                style={{ 
                  color: '#6b7280',
                  fontSize: '11px',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: '2px 4px'
                }}
              >
                {isExpanded ? 'Show less' : `+${items.length - 2} more`}
              </button>
            )}
          </div>
        );
      },
    },
    {
      field: "9",
      headerName: "Academics",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 300,
      flex: 1,
      sortable: true,
      renderCell: (params) => {
        const isExpanded = expandedCells[`${params.row.id}-academics`];
        const items = params.value && Array.isArray(params.value) ? params.value : 
                     params.value && typeof params.value === 'string' ? params.value.split(',') : [];
        const displayItems = isExpanded ? items : items.slice(0, 2);
        const hasMore = items.length > 2;

        return (
          <div style={{ 
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
            maxWidth: '100%',
            overflow: 'hidden'
          }}>
            {displayItems.length > 0 ? (
              displayItems.map((subject, idx) => (
                <span key={idx} style={{ 
                  backgroundColor: '#eff6ff',
                  color: '#2563eb',
                  padding: '2px 6px',
                  borderRadius: '8px',
                  fontSize: '11px',
                  fontWeight: '500'
                }}>
                  {subject?.trim()}
                </span>
              ))
            ) : (
              <span style={{ color: '#9ca3af', fontSize: '12px', fontStyle: 'italic' }}>
                No academics
              </span>
            )}
            {hasMore && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  toggleCellExpansion(params.row.id, 'academics');
                }}
                style={{ 
                  color: '#6b7280',
                  fontSize: '11px',
                  fontWeight: '500',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: '2px 4px'
                }}
              >
                {isExpanded ? 'Show less' : `+${items.length - 2} more`}
              </button>
            )}
          </div>
        );
      },
    },
    {
      field: "10",
      headerName: "School Name",
      headerClassName: "super-app-theme--header",
      type: "string",
      minWidth: 250,
      flex: 1,
      sortable: true,
      renderCell: (params) => (
        <div style={{ 
          fontSize: '13px',
          color: '#374151',
          fontWeight: '500',
          display: 'flex',
          alignItems: 'center',
          gap: '6px'
        }}>
          <span style={{ 
            backgroundColor: '#f9fafb',
            padding: '4px 8px',
            borderRadius: '6px',
            border: '1px solid #e5e7eb'
          }}>
            {params.value || 'No school specified'}
          </span>
        </div>
      ),
    },
  ];

  const saveResult = () => {
    console.log("clicked");
    setOpenSaveModal(true);
  };

  const cancel = () => {
    history.push("/recruiter/college-query");
  };

  const handleCellClick = (cell) => {
    let cel = cell.row;
    if (saveSelection && Array.isArray(saveSelection)) {
      console.log("inside if");
      let filteredValue = saveSelection.includes(cel);
      console.log("save selection", saveSelection, filteredValue);
      if (filteredValue === true) {
        let index = saveSelection.indexOf(cel);
        saveSelection.splice(index, 1);
        setSaveSelection(saveSelection);
        return;
      }
    } else if (
      saveSelection === "selected All" &&
      typeof saveSelection === "string"
    ) {
      const selectedRows = tableData.filter((item) =>
        selectedRowFromResultTable.includes(item.id)
      );
      let filteredValue = selectedRows.includes(cel);
      if (filteredValue === true) {
        let index = selectedRows.indexOf(cel);
        selectedRows.splice(index, 1);
        setSaveSelection(selectedRows);
        return;
      }
    }
  };

  useEffect(() => {
    if (Array.isArray(saveSelection)) {
      const ids = saveSelection.map((o) => o.id);
      let filtered = saveSelection.filter(
        ({ id }, index) => !ids.includes(id, index + 1)
      );
      setFilteredSaveSelection(filtered);
    } else if (typeof saveSelection === "string") {
      setFilteredSaveSelection("selected All");
    }
  }, [saveSelection]);

  console.log("saveSelection", saveSelection);
  const setPreviousSelection = () => {
    let prev = prevSelectionModel.current;
    setTimeout(() => {
      setSelectedRowFromResultTable(prev);
    });
  };
  const setPreviousSelectionData = () => {
    let prev = prevSelectionModelData.current;
    setTimeout(() => {
      setSaveSelection(prev);
    });
  };
  useEffect(() => {
    setPreviousSelection();
    setPreviousSelectionData();
  }, [page, tableData]);

  const onSelection = (ids) => {
    console.log("getting clled");
    if (Array.isArray(ids) && ids.length > 0) {
      setSelectedRowFromResultTable(ids);
      const selectedIDs = new Set(ids);
      let selectedRows = tableData.filter((item) => selectedIDs.has(item.id));
      // console.log('ids from the onSelection', ids, selectedRows, selectedRows.length)
      // let filteredValue = saveSelection.filter(item => selectedIDs.has(!item.id))
      // selectedRows = filteredValue
      if (page !== 1) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      } else if (page === 1 && selectedRows?.length === tableData.length) {
        setSelectAll(true);
        if (from) {
          setSaveSelection(selectedRows);
        } else if (!from) {
          setShowGroupMessageAlert(true);
          setSaveSelection("selected All");
        }
      } else if (page === 1 && selectedRows?.length !== tableData.length) {
        setSelectAll(true);
        const selectedIDs = new Set(ids);
        setSaveSelection([...saveSelection, ...selectedRows]);
        // const selectedRows = tableData.filter(item => selectedIDs.has(item.id));
      }
    } else if (Array.isArray(ids) && ids.length === 0) {
      setSaveSelection([]);
      setSelectedRowFromResultTable([]);
      setFilteredSaveSelection([]);
    }
  };

  return (
    <Fragment>
      <AppHeader />
      <Modal centered={true} toggle={toggleModal} isOpen={isModalOpen}>
        <div style={{ padding: '20px' }}>
          <h5>Query Result Details</h5>
          <p>Additional functionality can be added here if needed.</p>
        </div>
      </Modal>
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
      <div className="query-result-container">
        <div className="inner-query-result-container">
          <div className="view-result container qr-header">
            <div>
              <button
                type="button"
                className="qr-back-btn"
                aria-label="Back"
                onClick={() => history.goBack()}
              >
                <img
                  src={require("../../assets/images/queryResult/back.png")}
                  alt="Back"
                  className="qr-back-img"
                />
              </button>
              <span className="qr-title-text" style={{ marginLeft: "10px" }}>Query Results</span>
              <span className="qr-title-divider"> | </span>
              <span className="qr-title-count">{`
                ${
                  queryResultData
                    ? queryResultData?.total_students
                    : from
                    ? tableData.length
                    : 0
                } Students Found`}</span>
            </div>
          </div>
          <div style={{ padding: "15px" }}>
            <p
              style={{ color: "#333333", opacity: "0.8" }}
              className="bold"
            >{`You are viewing ${
              tableData ? tableData?.length : 0
            } Student out of ${
              queryResultData ? queryResultData?.total_students : 0
            } Results`}</p>
          </div>
          {loading ? (
            <CustomLoader />
          ) : (
            <div
              className={
                paginationCount && paginationCount > 1
                  ? "table-container"
                  : "table-container-less"
              }
              style={{
                background: '#ffffff',
                borderRadius: '16px',
                padding: '16px',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                border: '1px solid #f1f5f9',
                margin: '16px 0',
              }}
            >
              <DataGrid
                className="result-table"
                pageSize={pageSize}
                rows={tableData}
                columns={columns}
                rowsPerPageOptions={[20]}
                checkboxSelection
                onSelectionModelChange={(ids) => onSelection(ids)}
                selectionModel={selectedRowFromResultTable}
                onCellClick={handleCellClick}
                getRowId={(row) => row?.id}
                disableSelectionOnClick={true}
                hideFooterPagination={true}
                hideFooterSelectedRowCount={false}
                rowHeight={120}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={(model) => {
                  setSortModel(model);
                  // Reset to first page on new sort and refetch server data
                  const rule = model && model[0] ? model[0] : null;
                  if (!from) {
                    // ensure we call API with sort rule
                    // if page isn't 1 already, set then fetch in effect; else fetch now
                    if (page !== 1) {
                      setPage(1);
                      // also fetch immediately with override so UI is responsive
                      getPageData(rule);
                    } else {
                      getPageData(rule);
                    }
                  }
                }}
                sx={{
                  border: 'none',
                  '& .MuiDataGrid-cell': {
                    borderColor: '#f3f4f6',
                    fontSize: '13px',
                  },
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#f8fafc',
                    '& .MuiDataGrid-columnHeader': {
                      fontSize: '14px',
                      fontWeight: 'bold',
                      color: '#374151',
                    },
                  },
                  '& .MuiDataGrid-row': {
                    '&:nth-of-type(even)': {
                      backgroundColor: '#fafafa',
                    },
                    '&:hover': {
                      backgroundColor: '#f3f4f6 !important',
                    },
                  },
                  '& .MuiDataGrid-cell:focus': {
                    outline: 'none !important',
                  },
                  '& .MuiDataGrid-row.Mui-selected': {
                    backgroundColor: '#e0f2fe !important',
                    '&:hover': {
                      backgroundColor: '#b3e5fc !important',
                    },
                  },
                  '& .MuiDataGrid-virtualScroller': {
                    '&::-webkit-scrollbar': {
                      width: '6px',
                      height: '6px',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#f1f5f9',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      background: '#87ceeb',
                      borderRadius: '3px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      background: '#5fb3d4',
                    },
                  }
                }}
              />
            </div>
          )}

          <div className="qr-footer-topline" />
          <div className="result-button-container">
            {/* {userData.is_premium === true ? (
              <button
                style={{ justifyContent: "center" }}
                className="qr-footer-btn qr-footer-btn-primary"
                onClick={() =>
                  saveSelection.length > 0 ? saveStudent() : ""
                }
              >
                <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                Save to My Students
              </button>
            ) : (
              <button
                style={{ justifyContent: "center" }}
                className="qr-footer-btn qr-footer-btn-primary"
                onClick={toggleModal}
              >
                <img src={require("../../assets/images/queryResult/save.png")} alt="" className="btn-icon" />
                Save to My Students
              </button>
            )} */}
            <button
              onClick={() =>
                saveSelection.length > 0 ? onGroupMessage() : null
              }
              className={`qr-footer-btn qr-footer-btn-secondary ${saveSelection.length === 0 ? 'disabled' : ''}`}
              style={{
                opacity: saveSelection.length > 0 ? 1 : 0.5,
                cursor: saveSelection.length > 0 ? "pointer" : "not-allowed"
              }}
              disabled={saveSelection.length === 0}
            >
              <img src={require("../../assets/images/queryResult/group.png")} alt="" className="btn-icon" />
              Group Message
            </button>
            <button
              onClick={
                from
                  ? () => convertArrayToTable(selectedAllData, "My File")
                  : () => exportResult()
              }
              style={{ justifyContent: "center" }}
              className="qr-footer-btn qr-footer-btn-secondary flex"
            >
              <img src={require("../../assets/images/queryResult/export.png")} alt="" className="btn-icon" />
              Export Results
              {loaderForExport && (
                <span>
                  <Loader
                    type="TailSpin"
                    color="#E36221"
                    height={20}
                    width={20}
                  />
                </span>
              )}
            </button>
            <button
              onClick={() => cancel()}
              className="qr-footer-btn qr-footer-btn-secondary"
            >
              <img src={require("../../assets/images/queryResult/close.png")} alt="" className="btn-icon" />
              Cancel
            </button>
          </div>
          {(() => {
            const totalPages = from ? Math.ceil(tableData.length / 20) : paginationCount;
            return paginationCount && totalPages > 1 ? (
              <div className="template-pagination-container">
                <div className="custom-pagination">
                  <button
                    type="button"
                    aria-label="Prev"
                    className={`pagination-btn ${page === 1 ? "disabled" : ""}`}
                    onClick={() => {
                      if (page > 1) {
                        prevSelectionModel.current = selectedRowFromResultTable;
                        prevSelectionModelData.current = saveSelection;
                        setPage(page - 1);
                      }
                    }}
                  >
                    <img
                      src={page === 1 ? pageLeftHide : pageLeft}
                      alt="Prev"
                      className="pagination-img"
                    />
                  </button>
                  <div className="pagination-center">
                    <img src={pageCenter} alt="Page" className="pagination-img" />
                    <span className="pagination-number" style={{color:'white'}}>{page}</span>
                  </div>
                  <button
                    type="button"
                    aria-label="Next"
                    className={`pagination-btn ${page >= totalPages ? "disabled" : ""}`}
                    onClick={() => {
                      if (page < totalPages) {
                        prevSelectionModel.current = selectedRowFromResultTable;
                        prevSelectionModelData.current = saveSelection;
                        setPage(page + 1);
                      }
                    }}
                  >
                    <img src={pageRight} alt="Next" className="pagination-img" />
                  </button>
                </div>
              </div>
            ) : null;
          })()}
        </div>
      </div>
      {showGroupMessageAlert && (
        <ShowAlert
          number={queryResultData?.total_students}
          onConfirm={onGroupMessage}
          onCancel={() => {
            setShowGroupMessageAlert(false);
            setSaveSelection([]);
            setSelectedRowFromResultTable([]);
          }}
        />
      )}
      {openSaveModal && (
        <SaveModal
          openSaveModal={openSaveModal}
          setOpenSaveModal={setOpenSaveModal}
          //duplicateQueryData={duplicateQueryData}
          //saveQueryData={selectedAllData}
          inputValueForSave={inputValue}
          setInputValueForSave={setInputValue}
          openErrorModal={true}
          setOpenErrorModal={setOpenErrorModal}
          //saveFromSavedResult={from ? true : false}
          // payloadForSaveResult={payloadForSaveResult}
        />
      )}
      {/* {
                openErrorModal && <ErrorModal
                    openErrorModal={openErrorModal}
                    setOpenErrorModal={setOpenErrorModal}
                    text="Query"
                />
            } */}
   </div>
      </div>
    </Fragment>
  );
};
export default QueryResultCCCComponent;